import {FC} from 'react'
import {Error404} from '../modules/errors/components/Error404'

const NotFoundPage: FC = () => (
  <div className='d-flex flex-column flex-center flex-column-fluid py-10'>
    <div className='card card-flush w-lg-650px py-5'>
      <div className='card-body py-15 py-lg-20 text-center'>
        <Error404 />
      </div>
    </div>
  </div>
)

export {NotFoundPage}
